import { Pane, PaneProps } from 'evergreen-ui'
import React, { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export const CampaignCardWrapper = ({ children, ...other }: Props & PaneProps) => {
  return (
    <Pane
      borderRadius={10}
      height='100%'
      display='flex'
      flexDirection='column'
      position='relative'
      background='white'
      {...other}
    >
      {children}
    </Pane>
  )
}
